function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.02 3.68002H14.32V1.08002C14.32 0.660024 14.08 0.400024 13.74 0.400024C13.68 0.400024 13.6 0.420024 13.54 0.440024L3.98 3.36002C3.56 3.50002 3.2 4.00002 3.2 4.48002V18.5C3.2 18.98 3.6 19.4 4.1 19.4H15.02C15.5 19.4 15.92 19 15.92 18.5V4.56002C15.92 4.08002 15.52 3.68002 15.02 3.68002ZM13.62 1.12002V3.66002H5.32L13.62 1.12002ZM15.22 18.5C15.22 18.6 15.12 18.7 15.02 18.7H5.22H4.1C4 18.7 3.9 18.6 3.9 18.5V4.56002C3.9 4.46002 4 4.36002 4.1 4.36002H15.02C15.14 4.36002 15.22 4.46002 15.22 4.56002V18.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.75
});

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.61647c85.svg";
export { ForwardRef as ReactComponent };